export default {
    cities: 'cities',
    citiesTitle: 'Title',
    citiesStatus: 'Status',
    editCities: 'Edit Status',
    addCities: 'New Status',
    provinces: 'search By provinces',
    provincesTitle: 'provinces',
    province: 'province',
}